const closestParent = (el, selector) => {
    let parent = el.parentNode;
    while (parent && !parent.matches(selector)) {
        parent = parent.parentNode;
    }
    return parent;
};

export {closestParent}; // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/utils/dom.js